import { useSelector } from 'react-redux';

import { CUSTOM_FIELDS_TARGET } from 'app/shared/components/customFields/CustomFieldsSection/CustomFieldsSection.constants';
import useCustomFieldsValidation from 'app/shared/components/customFields/CustomFieldsSection/hooks/useCustomFieldsValidation';
import _ from 'lodash';

import { selectPropertyAndLoanSummarySubjectPropertyData } from 'store/loanApplications/selectors';

import { ENTITY_TYPE_HREF_MAP } from '../../../EditModal.constants';

import { PROPERTY_INFO_CUSTOM_FIELDS_TARGETS } from './constants';

const useCustomFieldsForDrawer = ({ subtab, applicationId }) => {
  const isLoanAndLockSubtab = subtab === ENTITY_TYPE_HREF_MAP.LOAN_AND_LOCK;
  const isPropertyInfoSubtab = subtab === ENTITY_TYPE_HREF_MAP.PROPERTY_INFO;
  const subjectPropertyData = useSelector(selectPropertyAndLoanSummarySubjectPropertyData);
  const subjectPropertyId = subjectPropertyData?.propertyId ?? null;

  const target = isLoanAndLockSubtab
    ? CUSTOM_FIELDS_TARGET.LOAN
    : PROPERTY_INFO_CUSTOM_FIELDS_TARGETS;

  const isCapable = isLoanAndLockSubtab || (isPropertyInfoSubtab && !_.isNil(subjectPropertyId));
  const targetEntityId = isLoanAndLockSubtab ? applicationId : subjectPropertyId;

  const validation = useCustomFieldsValidation({
    applicationId: isCapable ? applicationId : null,
    target,
    targetEntityId: isCapable ? targetEntityId : null,
  });

  return {
    ...validation,
    isCapable,
    targetEntityId,
  };
};

export default useCustomFieldsForDrawer;
